import { useLocation } from 'wouter';
import { Icon } from './Icon.js';

type Props = {
  // When set, left button is "back" instead of "home". Optional onBack
  // overrides the default history.back behavior (e.g. to flush pending writes).
  leftMode?: 'home' | 'back';
  onBack?: () => void;
  // When the home button needs side effects (flush pending writes, abort fetch).
  onHome?: () => void;
};

export function AppHeader({ leftMode = 'home', onBack, onHome }: Props): JSX.Element {
  const [, setLocation] = useLocation();

  const handleLeft = () => {
    if (leftMode === 'back') {
      if (onBack) onBack();
      else window.history.back();
      return;
    }
    if (onHome) onHome();
    setLocation('/');
  };

  return (
    <header className="flex items-center justify-between px-4 pt-[max(12px,env(safe-area-inset-top))] pb-2">
      <button
        type="button"
        aria-label={leftMode === 'back' ? '返回' : '回首页'}
        onClick={handleLeft}
        className="h-11 w-11 -ml-2 flex items-center justify-center text-primary active:text-secondary"
      >
        <Icon name={leftMode === 'back' ? 'back' : 'home'} size={22} />
      </button>
      <button
        type="button"
        aria-label="设置"
        onClick={() => setLocation('/settings')}
        className="h-11 w-11 -mr-2 flex items-center justify-center text-primary active:text-secondary"
      >
        <Icon name="settings" size={22} />
      </button>
    </header>
  );
}
